import { THEME } from "../../theme";
import { TrackPlayPauseProps } from "./types";
import { styles } from "../../pages/Tracks/styles";
import { CustomIconButtonForPlayPause } from "./styles";
import { useContext } from "react";
import { UserDetailsContext } from "../../contexts";

export const TrackPlayPause: React.FC<TrackPlayPauseProps> = ({
  track,
  handlePlayButtonClick,
  setTrackToPlay,
  setIsTrackForPlay,
  trackToPlay,
  setVersionToPlay,
}) => {
  const { isEnterpriseAccount, enterprise } = useContext(UserDetailsContext);

  return (
    <>
      <div style={{ position: "relative", display: "inline-block" }}>
        <img
          style={{ ...styles.image, opacity: 0.6 }}
          src={
            track.track?.getImageUrl() &&
            track.track?.getImageUrl().includes("http")
              ? track.track?.getImageUrl()
              : isEnterpriseAccount
              ? enterprise?.image
              : "/assets/images/logo512.png"
          }
          alt={track.track?.getImageUrl()}
        />
        <CustomIconButtonForPlayPause
          onClick={(e) => {
            e.stopPropagation();
            setVersionToPlay(undefined);
            handlePlayButtonClick();
            setTrackToPlay((prev) => {
              const isPlaying = prev?.isPlaying ? !prev.isPlaying : true;
              return {
                track: track.track,
                url: track.trackUrl,
                isPlaying:
                  trackToPlay?.track?.getId() === track.track?.getId()
                    ? isPlaying
                    : true,
              };
            });
            setIsTrackForPlay(true);
          }}
        >
          {trackToPlay?.isPlaying &&
          trackToPlay?.track?.getId() === track.track?.getId() ? (
            <img
              style={{
                ...styles.pauseIcon,
                ...{
                  filter: THEME === "light" ? "invert(0%)" : "invert(100%)",
                },
              }}
              src="/assets/icons/TracksPageIcons/circle_pause_icon.svg"
              alt="icon"
            />
          ) : (
            <img
              style={{
                filter: "brightness(0) invert(1)",
                color: "white",
              }}
              src="/assets/icons/TracksPageIcons/play.svg"
              alt="icon"
            />
          )}
        </CustomIconButtonForPlayPause>
      </div>
    </>
  );
};
